import React from 'react';

export default function Tank9Icon({
  width = 64,
  height = 64,
  startColor = '#383838',
  midColor = '#ECECEC',
  endColor = '#383838'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 65.649 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_TankBody">
	<path fill="#E5E5E5" d="M26.462,87.273V18.809h12.612v68.465H26.462z" />
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="1.689" y1="99.7598" x2="63.8481" y2="99.7598">
		<stop offset="0" style={{stopColor: "#4D4D4D"}} />
		<stop offset="0.52" style={{stopColor: "#B2B2B2"}} />
		<stop offset="1" style={{stopColor: "#666666"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M1.689,87.023h62.159l-21.621,25.474H23.31L1.689,87.273" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="1.689" y1="53.041" x2="63.8481" y2="53.041">
		<stop offset="0" style={{stopColor: "#383838"}} />
		<stop offset="0.45" style={{stopColor: "#ECECEC"}} />
		<stop offset="0.55" style={{stopColor: "#D9D9D9"}} />
		<stop offset="0.76" style={{stopColor: "#A8A8A8"}} />
		<stop offset="0.77" style={{stopColor: "#A6A6A6"}} />
		<stop offset="1" style={{stopColor: "#383838"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M1.689,87.273V18.809h62.159v68.465H1.689" />
</g>
<g id="Group_FrontLegs">
	<path fill="#B2B2B2" d="M0,112.497V81.418h1.689v5.855l2.703,15.765h56.753l2.703-15.765v-5.855h1.801v31.079h-4.504v-4.505H4.392   v4.505H0z" />
	<path fill="#666666" d="M2.14,112.497v-4.505L0.788,87.273v-5.855h0.901v5.855l2.703,17.566h59.005l1.352-17.566v-5.855h0.9v31.079   h-2.252v-4.505H4.392v4.505H2.14z" />
	<path fill="#B2B2B2" d="M0,112.497V81.418h1.689v5.855l2.703,15.765h56.753l2.703-15.765v-5.855h1.801v31.079h-4.504v-4.505H4.392   v4.505H0z" />
	<path fill="#666666" d="M2.14,112.497v-4.505L0.788,87.273v-5.855h0.901v5.855l2.703,17.566h59.005l1.352-17.566v-5.855h0.9v31.079   h-2.252v-4.505H4.392v4.505H2.14z" />
	<path fill="#B2B2B2" d="M0,112.497V81.418h1.689v5.855l2.703,15.765h56.753l2.703-15.765v-5.855h1.801v31.079h-4.504v-4.505H4.392   v4.505H0z" />
	<path fill="#666666" d="M2.14,112.497v-4.505L0.788,87.273v-5.855h0.901v5.855l2.703,17.566h59.005l1.352-17.566v-5.855h0.9v31.079   h-2.252v-4.505H4.392v4.505H2.14z" />
	<path fill="#B2B2B2" d="M0,112.497V81.418h1.689v5.855l2.703,15.765h56.753l2.703-15.765v-5.855h1.801v31.079h-4.504v-4.505H4.392   v4.505H0z" />
	<path fill="#666666" d="M2.14,112.497v-4.505L0.788,87.273v-5.855h1.151v5.855l2.453,17.566h59.005l1.352-17.566v-5.855h0.9v31.079   h-2.252v-4.505H4.392v4.505H2.14z" />
</g>
<g id="Group_Railing">
	<path fill="#4C4C4C" d="M3.041,9.35h59.456v1.351H3.041V9.35z" />
	<path fill="#7F7F7F" d="M3.041,18.809V1.242h13.513v17.567h1.351V1.242h13.963v17.567h1.802V1.242h13.963v17.567h1.352V1.242   h13.513v17.567h1.352V0.003H1.689v18.806H3.041z" />
	<path fill="#4C4C4C" stroke="#4C4C4C" strokeWidth="0.25" d="M1.689,17.907h24.773v1.352H1.689V17.907z" />
	<path fill="#4C4C4C" stroke="#4C4C4C" strokeWidth="0.25" d="M39.075,17.907h24.773v1.352H39.075V17.907z" />
</g>
<g id="Group_Ladder">
	<path fill="#7F7F7F" d="M37.273,0.003v5.292h-9.009V0.003h-1.802v112.494h1.802v-5.405h9.009v5.405h1.802V0.003H37.273z    M37.273,105.29h-9.009V94.48h9.009V105.29z M37.273,93.129h-9.009V81.868h9.009V93.129z M37.273,80.517h-9.009V69.256h9.009   V80.517z M37.273,67.904h-9.009v-10.81h9.009V67.904z M37.273,55.293h-9.009V44.482h9.009V55.293z M37.273,42.681h-9.009v-10.81   h9.009V42.681z M37.273,30.52h-9.009V19.259h9.009V30.52z M37.273,17.907h-9.009V6.647h9.009V17.907z" />
</g>
    
      </g>
      <rect x="0" y="0" width="65.649" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
